// src/Header.js

import React from 'react';
import { Link } from 'react-router-dom';

// Jednoduchý komponent pre hlavičku
export default function Header() {
    return (
        <header>
            <h1>Účtovné a administratívne služby</h1>
            <nav className="header-nav">
                <Link to="/">Domov</Link>
                <Link to="/kalkulacka">Kalkulačka</Link>
                <Link to="/povinnosti">Povinnosti</Link>
                <Link to="/personalistika">Personalistika</Link>
            </nav>
        </header>
    );
}
